/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Hub_Credits_TitleInputs */

const en_legal_hub_credits_title = /** @type {(inputs: Legal_Hub_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

const pl_legal_hub_credits_title = /** @type {(inputs: Legal_Hub_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorzy`)
};

/**
* | output |
* | --- |
* | "Credits" |
*
* @param {Legal_Hub_Credits_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_hub_credits_title = /** @type {((inputs?: Legal_Hub_Credits_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Hub_Credits_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_hub_credits_title(inputs)
	return en_legal_hub_credits_title(inputs)
});